module.exports = __webpack_public_path__ + "img/open-cage-rate-icon.2da3a442.png";